import { Text } from "@chakra-ui/react";
import _ from "lodash";
import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { ColumnId } from "./constants";

type Row = {
  schoolForm: { tiebreaker: number | null } | null;
};
export function buildTiebreakerColumnDef<
  T extends Row
>(): ColumnDefWithTooltip<T> {
  return {
    accessorFn: (row) => row.schoolForm?.tiebreaker,
    id: ColumnId.Tiebreaker,
    header: "Tiebreaker",
    tooltip: "Sort by tiebreaker",
    cell: (props) => {
      const tieBreaker = props.row.original.schoolForm?.tiebreaker;

      if (tieBreaker == null) {
        return (
          <Text variant="placeholder" textAlign="right">
            No value
          </Text>
        );
      }

      return <Text textAlign="right">{_.round(tieBreaker, 2)}</Text>;
    },
  };
}
